import { AdditionalFields } from '../domain/entities/inspirationalTemplate';
import { INSPIRATIONAL_TEMPLATE_MAP as EN_MAP } from './inspirationalTemplateMap.en';

export const INSPIRATIONAL_TEMPLATE_MAP: Record<string, AdditionalFields> = {
  'b991864c-cd05-498d-85e2-03459fdeb6ec': {
    backgroundColor: '#F3FFE0',
    shortDescription:
      'Lasse dich davon inspirieren, wie dieses einseitige Template dem Scrollen ein Ende setzt und Erwartungen unterläuft.',
    features: [
      'Transparentes Video',
      'Mouseover-Animation',
      'Lauftext',
      'Benutzerdefinierter Code',
      'CSS Grid',
      'Assets Library zum Download',
    ],
    inspirationalAssets:
      EN_MAP['b991864c-cd05-498d-85e2-03459fdeb6ec'].inspirationalAssets,
  },
  'd674b741-2412-4260-af3f-c5f0e964fcd5': {
    backgroundColor: '#F4EDFF',
    shortDescription:
      'Beflügel deine Vorstellungskraft und bereite dich auf die Erkundung des Weltraums mit dieser Landingpage vor.',
    features: [
      'Scroll-Animation',
      'Loop-Animation',
      'Horizontales Scrollen',
      'Mouseover-Effekte',
      'Benutzerdefiniertes CSS',
    ],
    inspirationalAssets:
      EN_MAP['b991864c-cd05-498d-85e2-03459fdeb6ec'].inspirationalAssets,
  },
  '8de718ac-8cc4-4b69-88ab-4d92920c37a2': {
    backgroundColor: '#FFE8E4',
    shortDescription:
      'Setze ein Statement und verleihe dem Template mit dyanamischem Lauftext Bewegung.',
    features: [
      'Lauftext',
      'Scroll-Animation',
      'Loop-Animation',
      'Eingangsanimation',
      'Hintergrund-Scroll-Effekte',
      'CSS Grid',
    ],
    inspirationalAssets:
      EN_MAP['d674b741-2412-4260-af3f-c5f0e964fcd5'].inspirationalAssets,
  },
  '50d5ca42-112a-466a-aca2-fd8bc927a965': {
    backgroundColor: '#E2FFE2',
    shortDescription:
      'Lasse dich von den Scroll-Effekten und Animationen inspirieren, die Lesern die Botschaft dieser NRO näherbringen.',
    features: [
      'Scroll-Animation',
      'Loop-Animation',
      'Eingangsanimation',
      'Transparentes Video',
      'CSS Grid',
      'Stack',
    ],
    inspirationalAssets:
      EN_MAP['50d5ca42-112a-466a-aca2-fd8bc927a965'].inspirationalAssets,
  },
  '31ec1ed2-9432-46e2-8175-5e4ccab9b5b9': {
    backgroundColor: '#FFE6F1',
    shortDescription:
      'Erwecke Fakten, Statistiken und Zahlen mithilfe von Scrollytelling zum Leben.',
    features: [
      'Scroll-Animation',
      'Loop-Animation',
      'Eingangsanimation',
      'Lauftext',
      'Hintergrundverlauf',
      'Hintergrund-Scroll-Effekte',
    ],
    inspirationalAssets:
      EN_MAP['31ec1ed2-9432-46e2-8175-5e4ccab9b5b9'].inspirationalAssets,
  },
  '498fe8fb-46ba-45a5-9346-3bb5b1c9f61c': {
    backgroundColor: '#E6F2FF',
    shortDescription:
      'Entdecke die Mysterien der Astrologie mit dieser Website und lasse dich für dein nächstes Projekt inspirieren.',
    features: [
      'Mauseffekte',
      'Sticky-Effekt',
      'Horizontales Scrollen',
      'Scroll-Animation',
      'Benutzerdefinierter Code',
    ],
    inspirationalAssets:
      EN_MAP['498fe8fb-46ba-45a5-9346-3bb5b1c9f61c'].inspirationalAssets,
  },
};
